// @flow
import React from 'react';
import { connect } from 'react-redux';
import ReportTable from './ReportTable';
import ReportTopForm from './ReportTopForm';
import { getReport, BUS_ARRIVALS } from '../ReportSidebar/reportConstants';
import styles from './reportDisplay.css';
import * as selectors from '../../reducers';

type ReportDisplayPropTypes = {
  name: string,
  selected: string,
  key: string,
};

const ReportDisplay = ({
  name = '',
  selected = BUS_ARRIVALS,
}: ReportDisplayPropTypes) => (
  <div className={styles.reportDisplay}>
    <ReportTopForm
      reportKey={selected}
      report={getReport(selected)}
    />
    <ReportTable
      reportKey={selected}
    />
  </div>
);

export default connect(
  (state) => {
    const selected = selectors.getCurrentReportKey(state);
    return {
      test: 1,
      selected,
    };
  },
  undefined,
)(ReportDisplay);



// WEBPACK FOOTER //
// ./src/scripts/components/ReportDisplay/index.jsx